<template>
    <Content>
        <Modal modal_id="login_modal">
            <template v-if="!email_register">
                <div class="row mt-1">
                    <div class="col-lg-6">
                        <secondary-title>
                            Login
                        </secondary-title>

                        <Login :modal="true" modal_name="login_modal" />
                    </div>

                    <div class="col-lg-6">
                        <CreateAnAccount
                            :modal="true"
                            :modal_register="false"
                        />
                    </div>
                </div>
            </template>
            <div :style="email_register ? 'display:block;' : 'display:none'">
                <Register modal_name="login_modal" />
            </div>
        </Modal>
    </Content>
</template>

<script>
import { mapState } from "vuex";
import { CSecondaryTitle } from "../../Styles/Components/styled";
import { Content } from "./style";
import Modal from "../../Modal";
import CreateAnAccount from "../CreateAnAccount.vue";
import Register from "../register/Register.vue";
import Login from "../Login";

export default {
    name: "ModalLogin",
    components: {
        CreateAnAccount,
        Login,
        Register,
        Content,
        Modal,
        "secondary-title": CSecondaryTitle
    },
    computed: {
        ...mapState("clients", ["email_register"])
    }
};
</script>
